let mutations = {}

mutations.refreshDataDashboard = (state) => {
  state.dashBoard.refreshData++
}

mutations.getListEmployeeRoleIds = (state,value) => {
  state.listEmployeeRoleIds = value
}

mutations.getListEmployeeRoles = (state,value) => {
  state.listEmployeeRoles = value
}

mutations.getCurrentEmployeeRoleCode = (state,value) => {
  state.currentEmployeeRoleCode = value
}

mutations.getListFeature = (state,value) => {
  state.listFeature = value
}

mutations.getCurrentUser = (state,value) => {
  state.currentUser = value
}

mutations.getCompanyInfo = (state,value) => {
  state.companyInfo = value
}

mutations.getUserProfile = (state,value) => {
  state.userProfile = value
}

mutations.getEmployeeInfo = (state,value) => {
  state.employeeInfo = value
}

mutations.redirectLogin = (state,value) => {
  state.redirectLogin = value
}

mutations.increaseCoutWrongOTP = (state,value) => {
  state.countEnterWrongOTP++
}

mutations.setNavSub = (state,value) => {
  state.navSub = value
}
export default mutations

